var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1116",
    cx: 9,
    cy: 9,
    r: 7.5,
    stroke: "#FFA653",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9 6V9L10.5 10.5",
    stroke: "#FFA653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockPending);
export default __webpack_public_path__ + "static/media/clock-pending.d492e93a23561f825ce646b4c7434b45.svg";
export { ForwardRef as ReactComponent };